module.exports = __webpack_public_path__ + "static/card-business-f19d35238d0f433c68f0e24033095c49.png";